import { render, staticRenderFns } from "./Achat.vue?vue&type=template&id=3096415e&scoped=true&"
import script from "./Achat.vue?vue&type=script&lang=js&"
export * from "./Achat.vue?vue&type=script&lang=js&"
import style0 from "./Achat.vue?vue&type=style&index=0&id=3096415e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3096415e",
  null
  
)

export default component.exports